import React, { useState } from 'react';
import { useLocation } from 'react-router-dom'; // Import useLocation
import '../css/GiftcardBookEvent.css'; // Import the CSS file

function GiftcardBookEvent() {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const event = queryParams.get('event');
  const where = queryParams.get('where');
  const when = queryParams.get('when');
  const informations = queryParams.get('informations');

  const [formData, setFormData] = useState({
    email: '',
    ticket: '',
  });

  const [formSubmitted, setFormSubmitted] = useState(false);
  const [loading, setLoading] = useState(false); // Add loading state

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async () => {
    setLoading(true); // Set loading to true when submission starts
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_BASE_URL}/api/giftcard`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          ...formData,
          event,
          where,
          when,
          informations,
        }),
      });

      const data = await response.json();
      if (data.status === 200) {
        setFormSubmitted(true);
      } else {
        alert(data.message);
      }
    } catch (error) {
      console.error('Error:', error);
    } finally {
      setLoading(false); // Set loading to false when submission ends
    }
  };

  return (
    <div className="giftcard-book-event-container">
      <div className="logo-container">
        <img src={`${process.env.REACT_APP_ASSETS_URL}/logo.png`} alt="Logo" className="logo" />
      </div>
      <h2 className={formSubmitted ? 'hidden' : 'title'}>Prenota Evento</h2>
      <h2 className={formSubmitted ? 'success-title' : 'hidden'}>Ti sei prenotato, a presto!</h2>
      <h1 className={formSubmitted ? 'smile-title' : 'hidden'}>:)</h1>
      <div className={formSubmitted ? 'hidden' : 'info'}>Inserisci il codice biglietto ricevuto dopo l'acquisto della Gift Card per prenotarti all'evento.</div>
      <h4>{event}</h4>
      {!formSubmitted && (
        <form className="form" onSubmit={(e) => e.preventDefault()}>
          <label className="label" htmlFor="email">Email:</label>
          <input className="input" type="email" name="email" value={formData.email} onChange={handleChange} required />

          <label className="label" htmlFor="ticket">Codice Biglietto:</label>
          <input className="input" type="text" name="ticket" value={formData.ticket} onChange={handleChange} required />

          {loading ? (
            <div className="spinner-container">
              <div className="spinner"></div>
            </div>
          ) : (
            <button className="button" type="button" onClick={handleSubmit} disabled={loading}>
              Convalida
            </button>
          )}
        </form>
      )}
    </div>
  );
}

// Add spinner styles
const spinnerStyles = `
.spinner {
  border: 2px solid rgba(0, 0, 0, 0.1);
  border-radius: 50%;
  border-top: 2px solid #3498db;
  width: 12px;
  height: 12px;
  animation: spin 1s linear infinite;
}
`;

// Add keyframes for the spinner animation
const spinnerKeyframes = `
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
`;

// Add spinner container styles
const spinnerContainerStyles = `
.spinner-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50px; // Adjust height as needed
}
`;

// Inject spinner styles into the document
const styleSheet = document.styleSheets[0];
styleSheet.insertRule(spinnerStyles, styleSheet.cssRules.length);
styleSheet.insertRule(spinnerKeyframes, styleSheet.cssRules.length);
styleSheet.insertRule(spinnerContainerStyles, styleSheet.cssRules.length);

export default GiftcardBookEvent; 